import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ReviewReasonComponent } from 'src/app/admin/components/review-reason/review-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let require: any;
const FileSaver = require('file-saver');

@Component({
  selector: 'app-admin-management-stra',
  templateUrl: './admin-management-stra.component.html',
  styleUrls: ['./admin-management-stra.component.css'],
})
export class AdminManagementStraComponent implements OnInit {
  updateForm: FormGroup;
  private getApi = environment.url + environment.managementStratgeyGet;
  private updateStatusApi = environment.url + environment.updateStatus;
  /**
   * Constructs the AdminManagementStraComponent with required services.
   * Initializes the update form and mobile query listener.
   * @param changeDetectorRef Reference to Angular's change detector for triggering change detection.
   * @param media Service to match media queries for responsive design.
   * @param getdata Service to retrieve values or data needed by the component.
   * @param fb FormBuilder service for creating reactive forms.
   * @param makeapi Service for making API calls.
   * @param dialog Material dialog service for opening dialogs.
   * @param notify Service for displaying notifications.
   * @param appCom Reference to the root AppComponent.
   * @param http Angular HttpClient for HTTP requests.
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private getdata: ValueService,
    private fb: FormBuilder,
    private makeapi: ApiService,
    public dialog: MatDialog,
    private notify: NotifyService,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    // Initialize the update form with an incubator ID field
    this.updateForm = this.fb.group({
      incubatorId: [''],
    });

    // Initialize the mobile query listener to detect changes in the mobile query
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  incubaterName;
  /**
   * Initializes the component after Angular has finished initializing it.
   * Sets the incubator name from session storage, updates the form with the incubator ID,
   * fetches data from the API, and retrieves guideline data.
   */
  ngOnInit(): void {
    // Retrieve and set the incubator name from session storage
    this.incubaterName = sessionStorage.getItem('adminIncubName');

    // Update the form with the incubator ID from session storage
    let getform = this.updateForm.value;
    getform.incubatorId = sessionStorage.getItem('incubator');
    this.updateForm.patchValue(getform);

    // Fetch data from the API
    this.getDataApi();

    // Retrieve guideline data
    this.guidelineDatas();
  }
  getValue: any = {};
  /**
   * Fetches the data from the API using the incubator ID from session storage and updates the component's data on success.
   */
  getDataApi() {
    // Show the loading indicator
    this.getdata.amizhthLoader('show');

    // Make the API request
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('incubator'), '', 'get')
      .subscribe((data) => {
        // Hide the loading indicator and update the component's data
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
      });
  }

  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  /**
   * Downloads a PDF file from the given URL and saves it to the user's computer as the given filename.
   * Uses the FileSaver library to download the PDF.
   *
   * @param pdfUrl The URL of the PDF file to download.
   * @param pdfName The filename to save the PDF as.
   */
  download(pdfUrl: string, pdfName: string) {
    FileSaver.saveAs(pdfUrl, pdfName);
  }
  /**
   * Submits the approval form for the given key and status.
   * If the API call is successful, shows a success notification and refreshes the data.
   * If the API call fails, shows an error notification.
   *
   * @param keys - The unique identifier for the item to approve.
   * @param id - The status of the item (0 for rejected, 1 for approved).
   */
  approveBtn(keys, id) {
    // Create a new FormControl with the given key
    const fc = new FormControl('');
    // Add the FormControl to the form
    this.updateForm.addControl(keys, fc);
    // Set the value of the FormControl to the given id
    this.updateForm.controls[keys].setValue(id);
    // Show a loading indicator
    this.getdata.amizhthLoader('show');
    // Create a new object with the form values
    let getform = this.updateForm.value;
    // Make the API call to update the status
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        // Hide the loading indicator
        this.getdata.amizhthLoader('hide');
        // If the API call is successful, show a success notification and refresh the data
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          // Remove the FormControl from the form
          this.updateForm.removeControl(keys);
          // Refresh the data
          this.getDataApi();
        } else {
          // If the API call fails, show an error notification
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Submits the rejection reason form for the given key and status.
   * If the API call is successful, shows a success notification and refreshes the data.
   * If the API call fails, shows an error notification.
   *
   * @param keys - The unique identifier for the item to reject.
   * @param id - The status of the item (0 for rejected, 1 for approved).
   */
  rejectBtn(keys, id) {
    const fc = new FormControl('');
    this.updateForm.addControl(keys, fc);
    this.updateForm.controls[keys].setValue(id);
    this.getdata.amizhthLoader('show');
    let getform = this.updateForm.value;
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          // Show a success notification and refresh the data
          this.notify.notifysuccess(data.responseMessage);
          this.updateForm.removeControl(keys);
          this.getDataApi();
        } else {
          // Show an error notification
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Opens the ReviewReasonComponent dialog to review an item with the given key and status.
   * Refreshes the data after the dialog is closed.
   *
   * @param key - The unique identifier for the item to review.
   * @param status - The current status of the item.
   */
  reviewBtn(key, status) {
    const dialogRef = this.dialog.open(ReviewReasonComponent, {
      width: '390px',
      data: { _key: key, _status: status },
    });
    dialogRef.afterClosed().subscribe((result) => {
      // Refresh the data after the dialog is closed
      this.getDataApi();
    });
  }
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  guidelineDatas() {
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      this.guidelineValue = data[0].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.step++;
  }
  prevStep() {
    this.step--;
  }
}
